export enum StoleType {
  FlatPriest = 'flat_priest',
  StandingBackPriest = 'standing_back_priest',
  PastoralPriest = 'pastoral_priest',
  Deacon = 'deacon',
  V1Ordinary = 'v1_ordinary',
  V1Special = 'v1_special',
  V1RomanOrdinary = 'v1_roman_ordinary',
  V1RomanSpecial = 'v1_roman_special',
  V1DeaconStraight = 'v1_deacon_straight',
  V1DeaconLShaped = 'v1_deacon_l_shaped',
}
